import template from './index.html.twig';
import './index.scss';

Shopware.Component.register('sw-cms-preview-moorl-twig', {
    template
});
